import Input from '../Input'

import './styles.scss'

export default class SearchBar extends Input {}
